import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangleIcon } from 'lucide-react';
import { SectionHeading } from './ui/SectionHeading';
import { costs } from '../data/problems';
export function ProblemSection() {
  return <section className="border-t border-slate-600/30 bg-slate-950 py-16 sm:py-20" aria-labelledby="problem-title" data-id="element-153" data-mp="30hzhn1ayjuld">
      <div className="mx-auto max-w-4xl px-4" data-id="element-154" data-mp="2vp6euiz1uwbx">
        <div className="text-center" data-id="element-155" data-mp="39hcs9xatip7o">
          <SectionHeading id="problem-title" data-id="element-156" data-mp="39gb3yr4sk680">Does This Sound <span className="text-yellow-400" data-id="element-157" data-mp="35gkhv0q7me9t">Familiar?</span></SectionHeading>
          <p className="mx-auto mt-6 max-w-3xl text-lg leading-relaxed text-slate-300" data-id="element-158" data-mp="35in6bgbprzcf">
            You work on diesel engines or generator sets, or you want to move into this field, but the machine still
            feels like a set of separate systems. When someone talks about injection timing, oil pressure, turbo boost,
            voltage regulation, transfer switches or load-bank tests, you can&apos;t connect all the pieces with confidence.
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="mt-10 rounded-2xl border border-slate-600/70 bg-blue-950 p-6 shadow-lg shadow-black/30 sm:p-8" data-id="element-159" data-mp="jey9a4j147wk">
          <p className="mb-5 inline-flex items-center gap-2 text-xl font-extrabold uppercase text-stone-50" data-id="element-160" data-mp="124ebcwad48f3">
            <AlertTriangleIcon className="h-5 w-5 text-amber-400" aria-hidden="true" data-id="element-161" data-mp="171mv31b5skig" />
            The real cost:
          </p>
          <ul className="grid gap-4 sm:grid-cols-2" data-id="element-162" data-mp="1c2ao1siy7bfb">
            {costs.map(item => <li key={item} className="flex gap-3 text-sm leading-relaxed text-slate-300" data-id="element-163" data-mp="1g2cmztxatqqw">
                <span className="mt-1.5 h-2.5 w-2.5 shrink-0 rounded-full bg-yellow-400" aria-hidden="true" data-id="element-164" data-mp="3dtxhe0qbbiey" />
                {item}
              </li>)}
          </ul>
        </motion.div>

        <div className="mt-10 text-center" data-id="element-165" data-mp="ozqx899vhrwl">
          <p className="mx-auto max-w-2xl text-lg font-bold text-stone-50" data-id="element-166" data-mp="p0isfizk5nmc">
            You don&apos;t need more scattered information.
          </p>
          <p className="mt-3 text-2xl font-extrabold uppercase tracking-tight text-amber-400 sm:text-3xl" data-id="element-167" data-mp="y1glx7cdecqo">You need one organized system.</p>
        </div>
      </div>
    </section>;
}